<div class='acc-delivery-curriculum-tab-part'>

	@if(!sessionsWithSurveys().length) {
	<div>
		<i>No sessions with surveys available.</i>
	</div>
	}
	@else {
	<droplist class="views-droplist" [items]='sessionsWithSurveys()' [selectedItem]='selectedViewItem()'
		(selectionChange)='onDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='uniqueId'
		style='display:inline-block'>
	</droplist>

	@if(surveyCount(); as surveyCounts) {
	<div>
		<table style="width:100%;" class='pro-table pro-table-without-border pro-table-with-thin-rows'>
			<tr>
				<th>Session Info</th>
				<th>Value</th>
			</tr>
			<tr>
				<td>Attendees Present</td>
				<td class="counts-cell">{{surveyCounts.attendeesPresent}}</td>
			</tr>
			<tr>
				<td>Surveys Complete</td>
				<td class="counts-cell">{{surveyCounts.surveysComplete}}</td>
			</tr>
			<tr>
				<td>Accessibility Score</td>
				<td class="counts-cell">{{surveyCounts.session.accessibilityScore}}</td>
			</tr>
			<tr>
				<td>Communication Score</td>
				<td class="counts-cell">{{surveyCounts.session.communicationScore}}</td>
			</tr>
			<tr>
				<td>Organization Score</td>
				<td class="counts-cell"> {{surveyCounts.session.organizationScore}}</td>
			</tr>
			<tr>
				<td>Comments</td>
				<td class="counts-cell">
					<button style="min-width: 35px; min-height: 15px;"
						(click)="showDialog(surveyCounts.session.comments , 'Session: ' + surveyCounts.session.sessionName)"
						class="text-btn text-btn-not-inline">{{surveyCounts.session.commentsCount}}</button>
				</td>
			</tr>
			<tr>
		</table>
		<br>
		<!-- Check if 'surveyCounts.topics' has any topics; if not, display 'No topic surveys' -->
		@if(surveyCounts?.topics.length) {
		@for(topic of surveyCounts.topics; track $index) {
		<div>
			<h4>Topic: {{topic.topicName}}</h4>
			<table style="width:100%;" class='pro-table pro-table-without-border pro-table-with-thin-rows'>
				<tr>
					<th>Topic Info</th>
					<th>Value</th>
				</tr>
				<tr>
					<td>Relevance Score</td>
					<td class="counts-cell"> {{topic.relevanceScore}}</td>
				</tr>
				<tr>
					<td>Need Score</td>
					<td class="counts-cell"> {{topic.needScore}}</td>
				</tr>
				<tr>
					<td>Understanding Score</td>
					<td class="counts-cell"> {{topic.understandingScore}}</td>
				</tr>
				<tr>
					<td>Duration Score</td>
					<td class="counts-cell"> {{topic.durationScore}}</td>
				</tr>
				<tr>
					<td>Comments</td>
					<td class="counts-cell">
						<button style="min-width: 35px; min-height: 15px;"
							(click)="showDialog(topic.comments,'Topic: ' + topic.topicName)"
							class="text-btn text-btn-not-inline">{{topic.comments.length}}</button>
					</td>
				</tr>
			</table>
			<br>
			<!-- Check if 'topic.specialists' has any specialists; if not, display 'No specialist surveys' -->
			@if(topic.specialists.length) {
			@for(specialist of topic.specialists; track $index) {
			<div>
				<h4>{{topic.topicName}} Specialist: {{specialist.specialistName}}</h4>
				<table style="width:100%;" class='pro-table pro-table-without-border pro-table-with-thin-rows'>
					<tr>
						<th>Specialist Info</th>
						<th>Value</th>
					</tr>
					<tr>
						<td>Effectiveness Score</td>
						<td class="counts-cell"> {{specialist.effectivenessScore}}</td>
					</tr>
					<tr>
					<tr>
						<td>Knowledge Score</td>
						<td class="counts-cell"> {{specialist.knowledgeScore}}</td>
					</tr>
					<tr>
					<tr>
						<td>Professionalism Score</td>
						<td class="counts-cell"> {{specialist.professionalismScore}}</td>
					</tr>
					<tr>
					<tr>
						<td>Comments</td>
						<td class="counts-cell">
							<button style="min-width: 35px; min-height: 15px;"
								(click)="showDialog(specialist.comments, topic.topicName +' Specialist: ' + specialist.specialistName)"
								class="text-btn text-btn-not-inline">
								{{specialist.comments.length}}</button>
						</td>
					</tr>
				</table>
				<br>
			</div>
			}
			}
			@else {
			<div>
				<i>No specialist surveys.</i>
			</div>
			}
		</div>
		}
		}
		@else{
		<div>
			<i>No topic surveys.</i>
		</div>
		}
	</div>
	}
	@else {
	<div>
		<i>No Surveys added yet for the selected session.</i>
	</div>
	}
	}
</div>